import React from 'react';
import { NavLink } from 'react-router-dom';
import './BottomNav.css';

const PHONE = '9445879508';

const navItems = [
  { to: '/', label: 'Home',
    icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { to: '/tours', label: 'Tours',
    icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 17l3-9 4 4 4-7 4 12"/><path d="M2 20h20"/></svg> },
  { isCall: true, label: 'Call', href: `tel:+91${PHONE}`,
    icon: <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.73a16 16 0 0 0 6.29 6.29l.92-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg> },
  { to: '/map', label: 'Map',
    icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg> },
  { to: '/contact', label: 'Book',
    icon: <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav">
      {navItems.map((item, i) => {
        if (item.isCall) {
          return (
            <a key="call" href={item.href} className="bottom-nav__call" aria-label="Call Maggi Cabs">
              {item.icon}
              <span>{item.label}</span>
            </a>
          );
        }
        return (
          <NavLink key={item.to} to={item.to} end={item.to === '/'}
            className={({ isActive }) => `bottom-nav__item ${isActive ? 'active' : ''}`}>
            <span className="bottom-nav__icon">{item.icon}</span>
            <span className="bottom-nav__label">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
